import Container from '../reusable/Container';
import { formatLocaleDate, storageGet } from 'src/utils';
import { Button } from 'src/components/reusable/Buttons';
import Image from 'src/components/reusable/Image';
import { useAppDispatch } from 'src/store/hooks';
import {
  handleModalPurchaseError,
  handleModalPurchaseSuccess
} from 'src/store/actions/modal';
import { Paragraph } from 'src/components/reusable/Typography';
import PurchaseSummaryTable from './PurchaseSummaryTable';
import * as SVG from 'src/assets/icons';

const PurchaseSummary = () => {
  const dispatch = useAppDispatch();

  const purchaseSummary: IPurchaseSummary = storageGet('purchase_summary');

  const date = formatLocaleDate(new Date(), '. ');

  const tableData = [
    {
      title: 'Transaction date',
      value: date
    },
    {
      title: 'Value (qty):',
      value: `$${purchaseSummary.amount} (x${purchaseSummary.quantity})`
    },
    {
      title: 'Deliver to:',
      value: purchaseSummary.fullname
    },
    {
      title: 'Phone number:',
      value: purchaseSummary.phone
    },
    {
      title: 'Full name:',
      value: purchaseSummary.fullname
    },
    {
      title: 'Order amount:',
      value: `${purchaseSummary.naira}.00 NGN`
    },
    {
      title: 'Total amount:',
      value: `${purchaseSummary.naira}.00 NGN`
    }
  ];

  const handleConfirmPurchase = () => {
    if (purchaseSummary.fullname.includes('Alayo')) {
      dispatch(handleModalPurchaseSuccess(true));
    } else {
      dispatch(handleModalPurchaseError(true));
    }
  };

  return (
    <div className="mx-auto max-w-[30rem] py-10">
      <Container>
        <div>
          <Image
            className="mx-auto bg-[#E8F1FF] p-10 rounded-full mb-16"
            src={SVG.PaperGiftCard}
          />
          <Paragraph className="text-center mb-10">
            You’re about to send <span className="font-bold">2($80)</span> gift
            cards to Victoria Agbamoro. See transaction details below.
          </Paragraph>
        </div>
        <PurchaseSummaryTable tableData={tableData} />
        <Button onClick={handleConfirmPurchase} className="w-full">
          Pay now
        </Button>
      </Container>
    </div>
  );
};

export default PurchaseSummary;
